import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import FormFieldWrapper from '../../../../../common/components/FormFieldWrapper/FormFieldWrapper';
import TextInput from '../../../../../common/components/TextInput';
import { PrimaryButton } from '../../../../../common/buttons/PrimaryButton/PrimaryButton';

type Props = {
  code: string;
  label: string;
  tip?: string;
  helpLink?: string;
  helpLinkLabel?: string;
  className?: string;
};

export const CodeWrapper = ({
  code,
  label,
  tip,
  helpLink,
  helpLinkLabel,
  className,
}: Props) => {
  return (
    <FormFieldWrapper className={className}>
      <div className="edit-promoter-panel__label">{label}</div>
      {tip && (
        <div className="edit-promoter-panel__tip">
          {tip}
          {helpLink && (
            <a
              href={helpLink}
              className="edit-promoter-panel__help-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {helpLinkLabel}
            </a>
          )}
        </div>
      )}
      <div className="edit-promoter-panel__code-wrapper">
        <TextInput
          readOnly={true}
          className="edit-customer-chat__code-input"
          value={code}
        />

        <CopyToClipboard text={code}>
          <PrimaryButton className="edit-promoter-panel__code-button-copy">
            Copy
          </PrimaryButton>
        </CopyToClipboard>
      </div>
    </FormFieldWrapper>
  );
};
